import Text from '@atoms/Text';
import Button from '../../../atoms/design-system/Button';
import { Fragment } from 'react';
import { toast } from 'react-toastify';
import Image from '@atoms/Image';

export const opportunityListDescExample = `<ul class="mt-2 ml-6 text-gray-900 list-disc p4-regular">
    <li> Lorem Ipsum has been the industry's standard</li>
    <li> Contrary to popular belief, Lorem Ipsum</li>
    <li> There are many variations of passages</li>
    <li> Lorem Ipsum has been the industry's standard</li>
</ul>`;

export const opportunityHeading1Example = `<h3 class="!text-basicBlack p4-bold mt-4">Heading</h3>`;
export const opportunityParagraphExample = `<p class="!text-gray-900 p4-regular mt-2">Body</p>`;

export const copyText = async (text) => {
    await navigator.clipboard.writeText(text);
    toast.success('Copied to clipboard!');
};

const copyAltText = 'Once copied, paste it into the desired section';

export const TableOption1 = ({ columns, rows }) => (
    <>
        <Text content="Option 1:" className="mb-4 p4-semibold" />
        <table class="table-auto md:table-fixed w-full max-w-fit md:max-w-full">
            <thead>
                <tr class="border-2">
                    {columns.map((col, index) => (
                        <Fragment key={index}>
                            <th
                                align="left"
                                class="border-r-2 px-4 py-2 p4-semibold w-[150px]"
                            >
                                Heading {col + 1}
                            </th>
                        </Fragment>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, index) => (
                    <Fragment key={index}>
                        <tr class="border-2">
                            {columns.map((col, index) => (
                                <Fragment key={index}>
                                    <td
                                        align="left"
                                        class="border-r-2 px-4 py-2 p5-regular w-[150px]"
                                    >
                                        Cell {col + 1}
                                    </td>
                                </Fragment>
                            ))}
                        </tr>
                    </Fragment>
                ))}
            </tbody>
        </table>
        <div className="flex gap-2 items-center mt-4 bg-basicWhite">
            <Button
                buttonText="Copy"
                buttonType="secondary"
                buttonSize="extraSmall"
                type="button"
                prefixComponent={
                    <Image
                        src="/images/copy-template.svg"
                        alt="copy"
                        className="w-5 h-5"
                    />
                }
                onClick={() =>
                    copyText(
                        `<div class="overflow-x-auto"><table class="table-auto md:table-fixed w-full mt-2 max-w-fit md:max-w-full">` +
                            `<thead><tr class="border-2">` +
                            columns
                                .map(
                                    (col, index) =>
                                        `<th align="left" class="border-r-2 px-4 py-2 p4-semibold w-[150px]">Heading ${
                                            col + 1
                                        }</th>`
                                )
                                .join('') +
                            `</tr></thead><tbody>` +
                            rows
                                .map(
                                    (row, index) =>
                                        `<tr class="border-2">` +
                                        columns
                                            .map(
                                                (col, index) =>
                                                    `<td align="left" class="border-r-2 px-4 py-2 p5-regular w-[150px]">Cell ${
                                                        col + 1
                                                    }</td>`
                                            )
                                            .join('') +
                                        `</tr>`
                                )
                                .join('') +
                            `</tbody></table></div>`
                    )
                }
            />

            <Text
                content={copyAltText}
                className="p6-regular text-gray-600"
            />
        </div>
        <hr className="my-8" />
    </>
);

export const TableOption2 = ({ columns, rows }) => (
    <>
        <Text content="Option 2:" className="mb-4 p4-semibold" />
        <table class="table-auto w-full max-w-fit md:max-w-full">
            <thead>
                <tr class="border-2">
                    {columns.map((col, index) => (
                        <Fragment key={index}>
                            <th
                                align="left"
                                class={`border-r-2 px-4 py-2 p4-semibold ${
                                    col === 0
                                        ? 'w-[180px] min-w-[180px]'
                                        : 'min-w-[240px]'
                                }`}
                            >
                                Heading {col + 1}
                            </th>
                        </Fragment>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, index) => (
                    <Fragment key={index}>
                        <tr class="border-2">
                            {columns.map((col, index) => (
                                <Fragment key={index}>
                                    <td
                                        align="left"
                                        class={`border-r-2 px-4 py-2 p5-regular ${
                                            col === 0
                                                ? 'w-[180px] min-w-[180px]'
                                                : 'min-w-[240px]'
                                        }`}
                                    >
                                        Cell {col + 1}
                                    </td>
                                </Fragment>
                            ))}
                        </tr>
                    </Fragment>
                ))}
            </tbody>
        </table>
        <div className="flex gap-2 items-center mt-4 bg-basicWhite">
            <Button
                buttonText="Copy"
                buttonType="secondary"
                buttonSize="extraSmall"
                type="button"
                prefixComponent={
                    <Image
                        src="/images/copy-template.svg"
                        alt="copy"
                        className="w-5 h-5"
                    />
                }
                onClick={() =>
                    copyText(
                        `<div class="overflow-x-auto"><table class="table-auto w-full mt-2 max-w-fit md:max-w-full">` +
                            `<thead><tr class="border-2">` +
                            columns
                                .map(
                                    (col, index) =>
                                        `<th align="left" class="border-r-2 px-4 py-2 p4-semibold ${
                                            col === 0
                                                ? 'w-[180px] min-w-[180px]'
                                                : 'min-w-[240px]'
                                        }">Heading ${col + 1}</th>`
                                )
                                .join('') +
                            `</tr></thead><tbody>` +
                            rows
                                .map(
                                    (row, index) =>
                                        `<tr class="border-2">` +
                                        columns
                                            .map(
                                                (col, index) =>
                                                    `<td align="left" class="border-r-2 px-4 py-2 p5-regular ${
                                                        col === 0
                                                            ? 'w-[180px] min-w-[180px]'
                                                            : 'min-w-[240px]'
                                                    }">Cell ${col + 1}</td>`
                                            )
                                            .join('') +
                                        `</tr>`
                                )
                                .join('') +
                            `</tbody></table></div>`
                    )
                }
            />
            <Text
                content={copyAltText}
                className="p6-regular text-gray-600"
            />
        </div>
        <hr className="my-8" />
    </>
);

export const TableOption3 = ({ columns, rows }) => (
    <>
        <Text content="Option 3:" className="mb-4 p4-semibold" />
        <table class="table-auto w-full max-w-fit md:max-w-full">
            <thead>
                <tr class="border-2">
                    {columns.map((col, index) => (
                        <Fragment key={index}>
                            <th
                                align="left"
                                class={`border-r-2 px-4 py-2 p4-semibold ${
                                    col === columns.length - 1
                                        ? 'w-[180px] min-w-[180px]'
                                        : 'min-w-[240px]'
                                }`}
                            >
                                Heading {col + 1}
                            </th>
                        </Fragment>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, index) => (
                    <Fragment key={index}>
                        <tr class="border-2">
                            {columns.map((col, index) => (
                                <Fragment key={index}>
                                    <td
                                        align="left"
                                        class={`border-r-2 px-4 py-2 p5-regular ${
                                            col === columns.length - 1
                                                ? 'w-[180px] min-w-[180px]'
                                                : 'min-w-[240px]'
                                        }`}
                                    >
                                        Cell {col + 1}
                                    </td>
                                </Fragment>
                            ))}
                        </tr>
                    </Fragment>
                ))}
            </tbody>
        </table>

        <div className="flex gap-2 items-center mt-4 bg-basicWhite">
            <Button
                buttonText="Copy"
                buttonType="secondary"
                buttonSize="extraSmall"
                type="button"
                prefixComponent={
                    <Image
                        src="/images/copy-template.svg"
                        alt="copy"
                        className="w-5 h-5"
                    />
                }
                onClick={() =>
                    copyText(
                        `<div class="overflow-x-auto"><table class="table-auto w-full mt-2 max-w-fit md:max-w-full">` +
                            `<thead><tr class="border-2">` +
                            columns
                                .map(
                                    (col, index) =>
                                        `<th align="left" class="border-r-2 px-4 py-2 p4-semibold ${
                                            col === columns.length - 1
                                                ? 'w-[180px] min-w-[180px]'
                                                : 'min-w-[240px]'
                                        }">Heading ${col + 1}</th>`
                                )
                                .join('') +
                            `</tr></thead><tbody>` +
                            rows
                                .map(
                                    (row, index) =>
                                        `<tr class="border-2">` +
                                        columns
                                            .map(
                                                (col, index) =>
                                                    `<td align="left" class="border-r-2 px-4 py-2 p5-regular ${
                                                        col ===
                                                        columns.length - 1
                                                            ? 'w-[180px] min-w-[180px]'
                                                            : 'min-w-[240px]'
                                                    }">Cell ${col + 1}</td>`
                                            )
                                            .join('') +
                                        `</tr>`
                                )
                                .join('') +
                            `</tbody></table></div>`
                    )
                }
            />
            <Text
                content={copyAltText}
                className="p6-regular text-gray-600"
            />
        </div>
    </>
);
